export default "__VITE_ASSET__Dkr$cFxz__"